/**
 * @author      yewon@zumper.com (Yewon Lee)
 * @copyright   Copyright (c) 2017, Zumper
 * @description name related utility functions
 */

// try to parse first and last name out of user input full name, full name is formatted xxx xxx
export const parseFullName = (name?: string) => {
  try {
    const nameParts = name?.split?.(/ +/) ?? []
    const firstName = nameParts?.[0] ?? ''
    const lastName = nameParts.length > 1 ? nameParts.slice(1).join(' ') : ''

    return { firstName, lastName }
  } catch (err) {
    // error occurred, use name for both first name and last name
    return { firstName: name, lastName: name }
  }
}
